import { ROOT_URL } from 'config'
import PATHS from 'paths'
import { SECTION_TYPES } from './constants'

export const parseStructuredData = (data) => {
  try {
    return JSON.parse(data?.internal?.content)
  } catch {
    return {}
  }
}

export const getStructuredDataBreadcrumbs = (guide, title) => {
  if (!guide) return {}
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Guides',
        item: `${ROOT_URL}${PATHS.GENERAL.CONTENT_HUB}`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: guide.title,
        item: `${ROOT_URL}${PATHS.GENERAL.CONTENT_HUB}/${guide.slug}`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: title,
      },
    ],
  }
}

export const getStructuredDataHowToSteps = (article, url) => {
  let structuredData
  const stepSections = article?.sections?.filter(
    // eslint-disable-next-line no-underscore-dangle
    (section) => section.__typename === SECTION_TYPES.STEPS
  )

  if (stepSections?.length > 0) {
    if (stepSections[0].structuredDataHowToSteps) {
      structuredData = parseStructuredData(
        stepSections[0].structuredDataHowToSteps
      )
    } else {
      structuredData = {
        '@context': 'http://schema.org',
        '@type': 'HowTo',
        name: stepSections[0].title,
        description: article?.description?.description,
        step: [],
      }

      structuredData.step = stepSections.map((section) => ({
        '@type': 'HowToSection',
        name: section.title,
        itemListElement: section.steps.map((step) => ({
          '@type': 'HowToStep',
          name: step.title,
          text: step?.stepSummary?.stepSummary,
          url: `${url}#${step.slug}`,
        })),
      }))
    }
  }

  return structuredData || {}
}
